import styled from 'styled-components';

export const Container = styled.main`
  padding-top: 2.7rem;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;

  align-items: center;
  justify-content: center;

  margin: 0 2.4rem 7.7rem;
`;

export const Texto = styled.span`
  margin-top: 5.7rem;
  font-size: 1.4rem;
  font-style: normal;
  font-weight: 700;
  line-height: 1.8rem;
  letter-spacing: 0em;
  text-align: center;

  color: ${({ theme }) => theme.colors.PRIMARY};

  @media only screen and (min-width: 768px) {
    margin-top: 6.1rem;
    font-size: 2.2rem;
    line-height: 2.765rem;
    margin: 0 ${({ isBold }) => (isBold ? 0 : 2)}rem;
  }
`;
